import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=6f53e17c&scoped=true"
import script from "./error404.vue?vue&type=script&lang=js"
export * from "./error404.vue?vue&type=script&lang=js"
import style0 from "./error404.vue?vue&type=style&index=0&id=6f53e17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f53e17c",
  null
  
)

export default component.exports